import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Fab } from '../fab.model';

@Injectable()
export class FabService {
    fabs: BehaviorSubject<Fab[]> = new BehaviorSubject<Fab[]>([]);
    fabs$: Observable<Fab[]> = this.fabs.asObservable();

    constructor() { }

    setFab(fab: Fab) {
        this.fabs.next([fab]);
    }

    addFab(fab: Fab) {
        const fabs = this.fabs.getValue();
        fabs.push(fab);
        this.fabs.next(fabs);
    }

    clear() {
        this.fabs.next([]);
    }
}
